<template>
  <section class="w-full h-full d-flex flex-column">
    <div class="pda-default flex-grow-1 overflow-hidden d-flex flex-column">
      <div class="t-headline5">
        {{ $t("1663") }}
        <!-- 개인정보 입력 -->
      </div>
      <div class="t-body3 mgt-6 t-color-content1">
        {{ $t("1664") }}
        <!-- 매장을 선택하세요. -->
      </div>
      <div class="mgt-35">
        <div
          class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
          id="searchValueEl"
        >
          <div
            v-on:click="
              isSearch
                ? { click: resetSearch() }
                : { click: fetchStore(searchValue) }
            "
            style="z-index: 99999; position: absolute; right: 16px; top: 18px"
          >
            <i class="material-icons">
              {{ isSearch ? "close" : "search" }}
            </i>
          </div>

          <input
            type="text"
            class="mdc-text-field__input"
            v-validate="'required'"
            v-model="searchValue"
            ref="searchValue"
            id="searchValue"
            name="searchValue"
            maxlength="50"
          />
          <div class="mdc-notched-outline">
            <div class="mdc-notched-outline__leading"></div>
            <div class="mdc-notched-outline__notch">
              <label for="tf-outlined" class="mdc-floating-label">
                {{ $t("766") }}
                <!-- 매장이름 -->
              </label>
            </div>
            <div class="mdc-notched-outline__trailing"></div>
          </div>
        </div>
      </div>
      <div class="scroll-y">
        <div v-if="storeList.length > 0 && submitState">
          <div v-for="(store, index) in storeList" :key="index" class="mgt-29">
            <div class="mdc-form-field margin-bottom: 3px;">
              <div class="mdc-radio radio-red">
                <input
                  class="mdc-radio__native-control"
                  type="radio"
                  :value="store.id"
                  :id="`store${store.id}`"
                  v-model="selectedStore"
                />
                <div class="mdc-radio__background">
                  <div class="mdc-radio__outer-circle"></div>
                  <div class="mdc-radio__inner-circle"></div>
                </div>
              </div>
              <label :for="`store${store.id}`" class="t-body1">
                {{ store.name }}
              </label>
            </div>
            <!-- radio-addon-label -->
            <div class="t-body3 h-20 t-color-gray4" style="margin-left: 60px">
              {{ store.code }}
            </div>
          </div>
        </div>

        <div
          class="t-center mgt-29"
          v-else-if="!storeList.length && submitState"
        >
          <div class="t-subtitle3">
            {{ $t("768") }}
            <!-- 검색 결과가 없습니다. -->
          </div>
          <div class="t-color-content1 t-body3 mgt-8">
            {{ $t("769") }}
            <!-- 검색하신 내용을 다시 확인해주세요. -->
          </div>
        </div>

        <infinite-loading
          @infinite="fetchData"
          :identifier="infiniteId"
          spinner="spiral"
        >
          <div slot="no-more" class="mgt-16"></div>
          <div slot="no-results" class="mgt-16"></div>
        </infinite-loading>
      </div>
    </div>
    <div class="mgt-10">
      <div class="pda-default">
        <button
          class="mdc-button mdc-button--raised btn-red btn-big w-full"
          type="button"
          @click="regist()"
          :disabled="!selectedStore"
        >
          {{ $t("1666") }}
          <!-- 회원가입 -->
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 회원가입 - 매장 검색 및 선택 컴포넌트(sign up - store search & select information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import joinApi from "@/api/joinApi.js";
import { mapState, mapMutations } from "vuex";
import { joinMixin } from "@/mixins/join.js";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      isSearch: false,
      searchValue: "",
      selectedStore: "",
      storeList: [],
      submitState: false,
      searchValueTextField: null,
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date(),
      customState: "",
    };
  },

  mixins: [joinMixin],
  computed: {
    ...mapState("join", {
      join: (state) => state,
    }),

    // invalidCheck() {
    //     let returnValue = false
    //     if (this.submitState) {
    //         if (this.errors.has('searchValue')) {
    //             returnValue = true
    //             // this.validIcon = 'warning'
    //         }else {
    //             returnValue = false
    //             // this.validIcon = ''
    //         }
    //     }
    //     this.searchValueTextField.valid === !returnValue ? '' : this.searchValueTextField.valid = !returnValue
    //     return returnValue
    // },
  },

  created() {
    if (
      !this.join.responsibility ||
      !this.join.terms.TERMS_OF_SERVICE ||
      !this.join.name.first ||
      !this.join.name.last ||
      !this.join.loginId
    ) {
      this.moveJoin2Intro();
    }
  },

  mounted() {
    this.setMaterialUi();
  },

  methods: {
    // Store 변이 정의(define store mutation)
    ...mapMutations("join", ["SET_STORE", "INIT_JOIN_STORE"]),
    initData() {
      this.storeList = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
      this.isSearch = true;
    },
    setMaterialUi() {
      this.searchValueTextField = new MDCTextField(
        document.querySelector("#searchValueEl")
      );
      this.searchValueTextField.useNativeValidation = false;
      const buttonRipple = [].map.call(
        document.querySelectorAll(".mdc-button"),
        function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        }
      );
    },
    resetSearch() {
      this.searchValue = "";
      this.isSearch = false;
      this.storeList = Array();
    },
    fetchStore() {
      this.initData();
    },
    fetchData($state) {
      if (this.totalPages >= this.currentPage) {
        this.$validator
          .validateAll()
          .then((resultValid) => {
            this.submitState = true;
            if (resultValid) {
              let params = {
                name: this.searchValue,
                page: this.currentPage,
                size: 10,
              };
              joinApi
                .searchStore(params)
                .then((response) => {
                  let responseData = response.data.data;

                  this.storeList = this.storeList.concat(responseData.content);
                  this.currentPage++;
                  this.totalPages = responseData.totalPages;

                  if (responseData.content.length) {
                    $state.loaded();
                  } else {
                    $state.complete();
                  }

                  if (this.storeList.length > 0) {
                    this.isNoData = false;
                  } else {
                    this.isNoData = true;
                  }
                  // this.storeList = response.data.data.content

                  this.selectedStore = "";
                })
                .catch((err) => {});
            } else {
              $state.complete();
            }
          })
          .catch((err) => {
            console.log("err=>", err);
          });
      } else {
        $state.complete();
      }
    },

    // 회원가입 API 호출(regist member)
    regist() {
      let responseData = null;
      if (this.selectedStore) {
        this.SET_STORE(this.selectedStore);
        let params = this.join;
        joinApi
          .register(params)
          .then((response) => {
            console.log(response.data.data);

            responseData = response.data.data;
            if (responseData.status.value === "ACTIVATION") {
              this.$router.push({ name: "Join2CompleteApproved" });
            } else {
              this.$router.push({ name: "Join2CompleteUnapproved" });
            }
          })
          .catch((err) => {
            console.log(err.response);
            responseData = err.response.data.meta;
            let errMsg = this.$t(`system.err.${responseData.errCode}`);

            // if (responseData.errCode === 1100) {
            //     errMsg = 'Todo-입력 정보가 잘못되었습니다. 입력한 정보를 확인해주세요.'
            // }else if (responseData.errCode === 1217) {
            //     errMsg = 'Todo-이미 등록된 사용자 아이디 입니다. 다른 아이디로 시도해 주세요.'
            // }else if (responseData.errCode === 1218) {
            //     errMsg = 'Todo-이미 등록된 사용자 아이디 입니다. 다른 아이디로 시도해 주세요.'
            // }

            this.$error({ content: errMsg }).then(() => {
              this.$router.push("/login");
            });
          });
      } else {
        this.$snackOpen({
          contents: this.$t("947"), //매장을 선택하세요.
          btnDisplay: "",
        }).then(() => {});
      }
    },
  },
};
</script>
